<po-container>
  <div class="po-md-2"><font class="po-font-title">Impressão</font></div>

  <po-button
    style="margin-left: 250px;"
    class="po-md-2"
    p-label="Imprimir"
    (p-click)="print()"
    p-icon="po-icon po-icon-print"
    p-type="primary"
  >
  </po-button>

</po-container>
<div style="margin-top: 20px">
  <po-page-default>
    <head>
      <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
      <title>Orçamento</title>
      <style type="text/css">
        @media print {
          /* invert the display (show/hide) properties of the main */
          /* aplication component and the printing component       */
          po-page-header-title {
            display: none;
          }
          po-container {
            display: none;
          }
          po-button {
            display: none;
          }
          div.po-page {
            display: none;
          }
          div.po-page-content {
            display: block;
          }
        }

        #apDiv1 {
          position: absolute;
          left: 17px;
          top: 6px;
          width: 238px;
          height: 82px;
          z-index: 1;
        }

        #apDiv2 {
          position: absolute;
          left: 1px;
          top: 0px;
          width: 785px;
          height: 97px;
          z-index: 2;
        }

        .style1 {
          font-family: Arial, Helvetica, sans-serif;
          margin-left: 5px;
        }

        #apDiv3 {
          position: absolute;
          left: -1px;
          top: 97px;
          width: 787px;
          height: 258px;
          z-index: 3;
        }

        #apDiv4 {
          position: absolute;
          left: 2px;
          top: 113px;
          width: 782px;
          height: 40px;
          z-index: 4;
        }

        #apDiv5 {
          position: absolute;
          left: 1px;
          top: 119px;
          width: 171px;
          height: 22px;
          z-index: 5;
        }

        #apDiv6 {
          position: absolute;
          left: 618px;
          top: 6px;
          width: 157px;
          height: 27px;
          z-index: 6;
        }

        .style2 {
          font-size: 16px;
          font-weight: bold;
        }

        #apDiv7 {
          position: absolute;
          left: 449px;
          top: 106px;
          width: 331px;
          height: 250px;
          z-index: 5;
        }

        #apDiv8 {
          position: absolute;
          left: 6px;
          top: 187px;
          width: 790px;
          height: 95px;
          z-index: 6;
        }

        #apDiv9 {
          position: absolute;
          left: 6px;
          top: 187px;
          width: 365px;
          height: 103px;
          z-index: 6;
        }

        #apDiv10 {
          position: absolute;
          left: 71px;
          top: 190px;
          width: 699px;
          height: 16px;
          z-index: 7;
        }

        #apDiv11 {
          position: absolute;
          left: 65px;
          top: 216px;
          width: 195px;
          height: 38px;
          z-index: 8;
        }

        #apDiv12 {
          position: absolute;
          left: 64px;
          top: 229px;
          width: 261px;
          height: 14px;
          z-index: 8;
        }

        .style6 {
          font-family: Arial, Helvetica, sans-serif;
          font-weight: bold;
        }

        #apDiv13 {
          position: absolute;
          left: 0px;
          top: 294px;
          width: 787px;
          height: 194px;
          z-index: 6;
        }

        .style7 {
          font-family: "Times New Roman", Times, serif;
        }

        #apDiv14 {
          position: absolute;
          left: 2px;
          top: auto;
          /*633px;*/
          width: 787px;
          height: 127px;
          z-index: 7;
          border: 1px solid;
        }

        #apDiv15 {
          position: absolute;
          left: 1px;
          top: auto;
          margin-top: 130px;
          /*765px; */
          width: 789px;
          height: 113px;
          z-index: 8;
        }

        #apDiv16 {
          /*  position: absolute; */
          left: 4px;
          /* top: 636px; */
          width: 785px;
          height: 29px;
          z-index: 9;
        }

        .style8 {
          font-size: 24px;
        }

        #apDiv17 {
          position: absolute;
          left: 3px;
          top: 668px;
          width: 785px;
          height: 85px;
          z-index: 10;
        }
      </style>
    </head>

    <body style="align-items: right; margin: 5px">
      <div id="apDiv2">
        <div align="right">
          <img
            src="../../../assets/logo.png"
            alt="Logo"
            width="220"
            height="69"
          />
        </div>
      </div>
      <div id="apDiv2">
        <div align="right">
          <span class="style1"><strong></strong><br /></span>
        </div>
      </div>
      <div id="apDiv3">
        <p>
          __________________________________________________________________________________________________
        </p>
        <p>
          __________________________________________________________________________________________________
        </p>
        <table width="782" border="0">
          <tr>
            <td width="95">
              <div align="left"><span class="style6">Cliente </span></div>
            </td>
            <td width="428">{{ this.nomeCliente }} <br /></td>
          </tr>

          <tr>
            <td>
              <div align="left"><span class="style6">CNPJ </span></div>
            </td>
            <td>{{ this.cnpj }}</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
        </table>
        <p>&nbsp;</p>
      </div>
      <div id="apDiv4">
        <div class="style1" id="apDiv6">
          <div align="left" class="style2">
            <div align="right">DATA: {{ this.data }}</div>
          </div>
        </div>
      </div>
      <div class="style1" id="apDiv5">
        <div align="left" class="style2">Orçamento N° {{ this.pedido }}</div>
      </div>
      <div id="apDiv13">
        <table
          width="786"
          height="20"
          border="1"
          cellpadding="2"
          cellspacing="0"
          bordercolor="#000000"
        >
          <tr>
            <th width="51" scope="col">
              <div align="left" class="style7">Item</div>
            </th>
            <th width="100" scope="col">
              <div align="left" class="style7">Código</div>
            </th>
            <th width="301" scope="col">
              <div align="left" class="style7">Descrição</div>
            </th>
            <th width="37" scope="col">
              <div align="left" class="style7">UM</div>
            </th>
            <th width="65" scope="col">
              <div align="left" class="style7">Qtd.</div>
            </th>
            <th width="69" scope="col">
              <div align="left" class="style7">Preço R$</div>
            </th>
            <th width="73" scope="col">
              <div align="left" class="style7">Total R$</div>
            </th>
          </tr>

          <tr *ngFor="let item of itens">
            <td>
              <span class="style1">{{ inteiro(item.item) + 1 }}</span>
            </td>
            <td>
              <span class="style1">{{ item.codProduto }}</span>
            </td>
            <td>
              <span class="style1">{{ item.DescProduto }}</span>
            </td>
            <td>
              <span class="style1">{{ item.un }}</span>
            </td>
            <td>
              <span class="style1">{{ item.quantidade }}</span>
            </td>
            <td>
              <span class="style1">{{ formatValor(item.precoImposto) }}</span>
            </td>
            <td>
              <span class="style1">{{ formatValor(item.valorTotal) }}</span>
            </td>
          </tr>
        </table>
        <p>
          __________________________________________________________________________________________________
        </p>
        <table
          width="786"
          border="1"
          cellpadding="2"
          cellspacing="0"
          bordercolor="#000000"
        >
          <tr>
            <th width="146" scope="col">
              <span align="center" class="style1"><strong>Total</strong></span>
            </th>
          </tr>
          <tr>
            <td>
              <div align="center" class="style1">{{ this.sTotalLiq }}</div>
            </td>
          </tr>
        </table>
        <p><br /></p>

        <div id="apDiv14">
          <div class="style6" id="apDiv16">
            <div align="center" class="style8">Informações Gerais</div>
          </div>

          <table width="786" height="82" border="0">
            <tr>
              <th width="196" scope="row">
                <div align="left">
                  <span class="style1">Forma de pagamento</span>
                </div>
              </th>
              <td width="571">
                <span class="style1">{{ this.condPag }}</span>
              </td>
            </tr>
            <tr>
              <th scope="row">
                <div align="left"></div>
              </th>
              <td></td>
            </tr>
            <tr>
              <th scope="row"></th>
              <td></td>
            </tr>
          </table>
        </div>

        <div class="style1" id="apDiv15">
          <strong>Obs..:</strong> {{ this.obs }}
          <p></p>
         {{this.msgObs}}
        </div>

        <!--<div id="apDiv17">
                    
                </div> -->
      </div>

      <p align="right"><br /></p>
    </body>
  </po-page-default>
</div>
